import IState from "../state"
import { Modules } from "./moduleContext.reducer"

export const getCurrentModule = (state: IState): Modules | undefined => state.moduleContext.currentModule

export const getPreviousModule = (state: IState): Modules | undefined => state.moduleContext.previousModule

export const loading = (state: IState): boolean => state.moduleContext.loading
